import Vue from "vue";
import InlineAudio from "./inline-audio";

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-inline-audio]").forEach((el, i) => {

    new Vue({
      el: el,
      components: { InlineAudio },
      data: {
        id: `inline-audio-${i + 1}`,
        audioId: el.getAttribute('data-audio-id'),
        audioTitle: el.getAttribute('data-audio-title'),
        audioUrl: el.getAttribute('data-audio-url'),
      },
      template:
        `
          <InlineAudio :id=id :audioId=audioId :audioTitle=audioTitle :audioUrl=audioUrl></InlineAudio>
        `
    });
  })
});
